/**
 * Shipped craft presets:
 * Mechagora (brand default) · Midnight Slate · Cream Paper · Accessible Signals
 */

import {
  tokensFromAccessible,
  tokensFromCream,
  tokensFromMechagora,
  tokensFromMidnight,
  type DeskTokenSet,
} from '@/shared/theme/systems/desk-tokens'
import { buildThemeDefinition } from '@/shared/theme/systems/build-definition'
import type { ThemeDefinition } from '@/shared/theme/types/theme.types'

const mechagoraDark = tokensFromMechagora('dark')
const mechagoraLight = tokensFromMechagora('light')
const midnight = tokensFromMidnight()
const cream = tokensFromCream()
const accessibleDark = tokensFromAccessible('dark')
const accessibleLight = tokensFromAccessible('light')

export const mechagoraDarkTheme: ThemeDefinition = buildThemeDefinition(
  'mechagora',
  'Mechagora',
  'dark',
  mechagoraDark
)
export const mechagoraLightTheme: ThemeDefinition = buildThemeDefinition(
  'mechagora',
  'Mechagora',
  'light',
  mechagoraLight
)

export const midnightSlateDarkTheme: ThemeDefinition = buildThemeDefinition(
  'midnight-slate',
  'Midnight Slate',
  'dark',
  midnight
)
export const midnightSlateLightTheme: ThemeDefinition = buildThemeDefinition(
  'midnight-slate',
  'Midnight Slate',
  'light',
  cream
)

export const creamPaperLightTheme: ThemeDefinition = buildThemeDefinition(
  'cream-paper',
  'Cream Paper',
  'light',
  cream
)
export const creamPaperDarkTheme: ThemeDefinition = buildThemeDefinition(
  'cream-paper',
  'Cream Paper',
  'dark',
  midnight
)

export const accessibleSignalsDarkTheme: ThemeDefinition = buildThemeDefinition(
  'accessible-signals',
  'Accessible Signals',
  'dark',
  accessibleDark
)
export const accessibleSignalsLightTheme: ThemeDefinition = buildThemeDefinition(
  'accessible-signals',
  'Accessible Signals',
  'light',
  accessibleLight
)

export type ShippedPresetId =
  | 'mechagora'
  | 'midnight-slate'
  | 'cream-paper'
  | 'accessible-signals'

export const PRESET_TOKENS: Record<
  ShippedPresetId,
  { light: DeskTokenSet; dark: DeskTokenSet }
> = {
  mechagora: { light: mechagoraLight, dark: mechagoraDark },
  'midnight-slate': { light: cream, dark: midnight },
  'cream-paper': { light: cream, dark: midnight },
  'accessible-signals': { light: accessibleLight, dark: accessibleDark },
}
